var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    { attrs: { "max-width": "800" } },
    [
      _c("w-card-title", [_vm._v("Peppol Reporting")]),
      !_vm.hasAccess
        ? _c(
            "w-card-content",
            [
              _c(
                "w-row",
                [
                  _c("w-col", { attrs: { xs: "12" } }, [
                    _vm._v("Toegang geweigerd"),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : [
            _c(
              "w-scroll-view",
              { attrs: { tag: "w-card-content" } },
              [
                _c(
                  "w-row",
                  [
                    _c(
                      "w-col",
                      { attrs: { xs: "6" } },
                      [
                        _c("app-month-select", {
                          attrs: { label: "Maand", fancy: "" },
                          model: {
                            value: _vm.month,
                            callback: function ($$v) {
                              _vm.month = $$v
                            },
                            expression: "month",
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "w-col",
                      { attrs: { xs: "6" } },
                      [
                        _c("w-input-number", {
                          attrs: { decimals: 0, label: "Jaar", fancy: "" },
                          model: {
                            value: _vm.year,
                            callback: function ($$v) {
                              _vm.year = $$v
                            },
                            expression: "year",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "w-card-actions",
              [
                _c("w-spacer"),
                _c(
                  "w-button",
                  {
                    staticClass: "mr",
                    attrs: { disabled: _vm.sending },
                    on: {
                      click: function ($event) {
                        return _vm.sendEUSR()
                      },
                    },
                  },
                  [_vm._v("EUSR versturen")]
                ),
                _c(
                  "w-button",
                  {
                    attrs: { disabled: _vm.sending },
                    on: {
                      click: function ($event) {
                        return _vm.sendTSR()
                      },
                    },
                  },
                  [_vm._v("TSR versturen")]
                ),
              ],
              1
            ),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }